import { render, staticRenderFns } from "./MonthlyStatisticsList.vue?vue&type=template&id=13375d6d&"
import script from "./MonthlyStatisticsList.vue?vue&type=script&lang=ts&"
export * from "./MonthlyStatisticsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports